const BucketRedirecter = () => window.location.href = `https://public-assets-finaer-arg.s3.us-west-1.amazonaws.com${window.location.pathname}`;
  
export default BucketRedirecter;